<template>
    <div class="animated fadeIn">
        <form @submit="ValidarForm">
        <div class="row">
            <div class="col-sm-12">
                <div class="card">
                    <header class="card-header">
                        <div class="d-flex">
                            <strong class="align-self-center">
                                {{ $t("sectionPesquisaSatisfacao.pesquisaSatisfacaoConf") }}</strong>
                        </div>
                    </header>
                    <div v-if="loading" class="loading-container">
                        <RotateSquare class="loading-position animated fadeIn" size="60px"></RotateSquare>
                    </div>
                    <div v-else class="card-body">
                        <div class="row">
                            <div class="col-sm-12 col-md-4 col-lg-4 col-xl-6">
                                <div class="form-group">
                                    <strong for>* {{ $t("sectionPesquisaSatisfacao.textoEnviar") }}</strong>
                                    <textarea v-model="viewModel.mensagem" class="form-control" type="text"
                                        :placeholder="$t('sectionPesquisaSatisfacao.corpoPlaceholder')" maxlength="1024"
                                        required />
                                    <div>
                                        <label class="btn" type="" v-for="tag in tags" :key="tag.id"
                                            @click="handleTagSelected(tag.id)" style="color: blue;">
                                            {{ tag.id }}
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-4 col-lg-4 col-xl-6">
                                <div class="row mb-2">
                                    <strong for style="margin-right: 10%;">{{ $t("sectionPesquisaSatisfacao.statusPesquisa")
                                    }}</strong>
                                    <b-form-checkbox v-model="viewModel.ativo" name="check-button" switch>
                                        {{ $t("sectionPessoa.pessoaAtivo") }}
                                    </b-form-checkbox>
                                </div>
                                <div class="row mb-2">
                                    <strong for style="margin-right: 10%;">{{
                                        $t("sectionPesquisaSatisfacao.envioAutomatico") }}</strong>
                                    <b-form-checkbox v-model="viewModel.envioAutomatico" name="check-button" switch>
                                        {{ $t("sectionPessoa.pessoaAtivo") }}
                                    </b-form-checkbox>
                                </div>
                                <div class="row mb-2">
                                    <strong for style="margin-right: 3%;">{{ $t("sectionPesquisaSatisfacao.tempoEnvio")
                                    }}</strong>
                                    <input class="col-xl-2 form-control" v-model="viewModel.tempoEnvio" type="number"
                                        style="margin-right: 3%;" min="1" max="1440" required/>
                                    {{ $t("sectionPesquisaSatisfacao.minutos") }}

                                </div>
                                <div class="row mb-2">
                                    <strong for style="margin-right: 3%;">{{
                                        $t("sectionPesquisaSatisfacao.tempoAtendimento")
                                    }}</strong>
                                    <input class="col-xl-2 form-control" v-model="viewModel.tempoAtendimento" type="number"
                                        style="margin-right: 3%;" min="0" required/>
                                    {{ $t("sectionPesquisaSatisfacao.minutos") }}

                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <div class="col-sm-12">
                <div class="card">
                    <header class="card-header">
                        <div class="d-flex">
                            <strong class="align-self-center">
                                {{ $t("sectionPesquisaSatisfacao.pergunta") }}</strong>
                            <button class="ml-auto btn btn-info" type="button" @click="AdicionarPergunta()">
                                {{ $t("sectionPesquisaSatisfacao.incluirPergunta") }} <i class="fas fa-plus-circle"></i>
                            </button>
                        </div>
                    </header>
                    <div class="card-body">
                        <b-table :items="viewModel.perguntas" :fields="fields" show-empty :empty-text="$t('sectionPesquisaSatisfacao.nenhumaPergunta')">
                            <template #cell(numero)="data">
                                <span>{{ data.index + 1 }}</span>
                            </template>
                            <template #cell(descricao)="data">
                                <textarea required class="form-control" v-model="data.item.descricaoPergunta" type="text" />
                            </template>
                            <template #cell(obrigatorio)="data">
                                <b-form-checkbox v-model="data.item.obrigatorio" name="check-button"></b-form-checkbox>
                            </template>
                            <template #cell(tipoResposta)="data">
                                <select required :disabled="data.item.disabled" v-model="data.item.tipoResposta"
                                                class="form-control">
                                                <option :value="null">{{ $t("textSelecione") }}
                                                </option>
                                                <option v-for="option in tipoResposta" :value="option.id" :key="option.id">
                                                   {{ option.id }} - {{ option.label }}
                                                </option>
                                </select>
                            </template>
                            <template v-slot:cell(acoes)="data">
                                <div class="btn-group-sm">
                                    <b-button variant="danger" :title="$t('btRemover')" @click="Remover(data.item)">
                                        <i class="fas fa-trash-alt text-black"></i>
                                    </b-button>
                                </div>
                            </template>

                        </b-table>
                    </div>
                </div>
                <button class="btn btn-success" type="submit">
            {{ $t("btSalvar") }}
          </button>
            </div>
        </div>
    </form>

    </div>
</template>
  
<script>
import RotateSquare from "../../components/RotateSquare";

export default {
    name: "PesquisaSatisfacaoConfig",
    components: {
        RotateSquare
    },
    data() {
        return {
            locale: this.$i18n.locale,
            loading: false,
            viewModel: {
                contaId: this.$store.getters.getAutenticacao.contaSelecionadaId,
                mensagem: "",
                ativo: false,
                envioAutomatico: false,
                tempoEnvio: null,
                tempoAtendimento: null,
                perguntas: [],
            },

            tipoResposta: [
                { id:1, label:this.$t('sectionPesquisaSatisfacao.comentario') },
                { id:2, label:this.$t('sectionPesquisaSatisfacao.estrela') },
                { id:3, label:this.$t('sectionPesquisaSatisfacao.nps') },
                { id:4, label:this.$t('sectionPesquisaSatisfacao.simNao') }
            ],
            fields: [
                { key: 'numero', label: this.$t('sectionPesquisaSatisfacao.numero') },
                { key: 'descricao', label: this.$t('sectionPesquisaSatisfacao.descricaoPergunta') },
                { key: 'obrigatorio', label: this.$t('sectionPesquisaSatisfacao.obrigatorio'), tdClass: 'largura-menor'},
                { key: 'tipoResposta', label: this.$t('sectionPesquisaSatisfacao.tipoResposta'),tdClass: "CustomTd"},
                { key: "acoes", label: this.$t("sectionMensagemPadrao.mensagempadraoAcoes")}
            ]
        };
    },
    computed: {
        tags() {
            return [
                {
                    id: "[URL_PESQUISA]",
                    descricao: this.$t("sectionNovoMensagemPadrao.urlCadastroCliente")
                },
                {
                    id: "[NOME_CLIENTE]",
                    descricao: this.$t("sectionNovoMensagemPadrao.nomeCliente")
                },
                {
                    id: "[NOME_ATENDENTE]",
                    descricao: this.$t("sectionNovoMensagemPadrao.nomeAtendente")
                }
            ];
        },
    },
    watch: {
    },
    beforeMount() {
        this.Obter();
    },
    methods: {
        handleTagSelected(tagId) {
            this.viewModel.mensagem += " " + tagId;
        },
        AdicionarPergunta() {
            if (this.viewModel.perguntas.length < 5) {
                const novaPergunta = {}
                novaPergunta.id = this.generateGuid();
                novaPergunta.tipoResposta = null
                this.viewModel.perguntas.push(novaPergunta);
            } else {
                const limitePerguntas = this.$t(
                    "sectionPesquisaSatisfacao.limitePergunta"
                );

                this.$notify({
                    data: [limitePerguntas],
                    type: "warn",
                    duration: 10000
                });
            }
        },
        generateGuid() {
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                var r = Math.random() * 16 | 0,
                    v = c === 'x' ? r : (r & 0x3 | 0x8);
                return v.toString(16);
            });
        },
        Remover(itemRemover){

            const index = this.viewModel.perguntas.findIndex((item) => item.id === itemRemover.id);
            if (index !== -1) {
                this.viewModel.perguntas.splice(index, 1);
            }
        },
        ValidarForm(evt){
            evt.preventDefault();

            if(this.viewModel.perguntas.length === 0 ){
                const semPerguntas = this.$t(
                    "sectionPesquisaSatisfacao.semPergunta"
                );

                this.$notify({
                    data: [semPerguntas],
                    type: "warn",
                    duration: 10000
                });
                return;
            }

            if(!this.viewModel.mensagem.includes("[URL_PESQUISA]")){
                const semLink = this.$t(
                    "sectionPesquisaSatisfacao.semLink"
                );

                this.$notify({
                    data: [semLink],
                    type: "warn",
                    duration: 10000
                });
                return;
            }
            this.EditarPesquisa()
        },
        EditarPesquisa(){
            this.loading = true;

            this.viewModel.perguntas.forEach((item, index) => {
                item.index = index+1;
            });

            this.$http({
                url: "pesquisa-satisfacao/editar",
                data: this.viewModel,
                method: "POST"
            })
                .then(() => {
                    this.loading = false;
                    const pesquisaComSucesso = this.$t(
                        "sectionPesquisaSatisfacao.editadoSucesso"
                    );

                    this.$notify({
                        data: [pesquisaComSucesso],
                        type: "success",
                        duration: 10000
                    });
                })
                .catch((erro) => {
                    this.loading = false;
                    this.$notify({
                        data: [erro.response.data],
                        type: "warn",
                        duration: 10000
                    });
                });
        },
        Obter() {
            this.loading = true;
            this.$http({
                url:
                    "/pesquisa-satisfacao/obter/" +
                    this.$store.getters.getAutenticacao.contaSelecionadaId,
                method: "GET"
            })
                .then((response) => {
                    this.loading = false;
                    this.viewModel = response.data;
                    if(this.viewModel.perguntas.length > 0){
                        this.viewModel.perguntas.forEach((item) => {
                            item.disabled = true;
                        });
                    }
                })
                .catch((erro) => {
                    this.loading = false;
                    this.$notify({
                        data: erro.response.data.erros,
                        type: "warn",
                        duration: 10000
                    });
                });
        }
    }
};
</script>
<style >
.CustomTd {
    width: 25%
}
.largura-menor {
  width: 5%;
  text-align: center;
}
</style>